<template>
  <div class="category-management">
    <a-button type="primary" style="float: right;" @click="showAddCategoryModal">新增分类</a-button>

    <!-- 分类列表：分页显示 -->
    <a-table
      :dataSource="categories"
      :columns="categoryColumns"
      rowKey="id"
      :pagination="false"
      style="margin-top: 20px;"
    >
      <template v-slot:bodyCell="{ column, record, index }">
        <template v-if="column.key === 'sn'">
              {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key == 'name'">
          {{ record.name }}
        </template>
      
        <template v-if="column.key === 'operation'">
          <a-space>
            <a href="javascript:;" @click="showEditCategoryModal(record)">修改</a>
            <a-popconfirm title="确认删除该分类?" @confirm="deleteCategory(record)">
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </a-space>
        </template> 
      </template>
    </a-table>

    <!-- 分类新增/编辑模态框 -->
    <a-modal
      v-model:visible="categoryModalVisible"
      title="分类操作" 
      @ok="handleCategorySubmit"
      @cancel="handleCategoryCancel"
    >
      <a-form :label-col="labelCol"
      :rules="rules"
      ref="formRef"
      :model="categoryForm">

        <a-form-item label="排序" name="sort"   ref="sort">
          <a-input v-model:value="categoryForm.sort" placeholder="请输入排序" />
        </a-form-item>

        <a-form-item label="分类名称" name="name"   ref="name">
          <a-input v-model:value="categoryForm.name" placeholder="请输入分类名称" />
        </a-form-item>


      </a-form> 
    </a-modal>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted,toRaw,watch } from 'vue';
import http from '@/shared/http.service';
import { Uris } from '@/shared/const';
import { Table, Space, Button, Popconfirm, Modal, Form, Input, Select } from 'ant-design-vue';

const formRef = ref(); 

const categoryModalVisible = ref(false); // 模态框显示/隐藏
const categoryForm = reactive({
  id: null, // 分类ID，新增时为null
  name: '',
  sort:1,
  parentId: null,
});
const value = ref(); 
const categories = ref([]); // 分类列表 
const treeData = ref([]); // 树
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0,
}); // 分页配置

const labelCol = { style: { width: '90px' } }; // 表单label宽度

// watch(value, () => {
// console.log("value"+value.value);
// });
// 获取分类列表（包括分页）
const fetchCategories = async () => {
  try {
      // {params: { pageIndex: page, pageSize: pagination.pageSize },}
       
      http.get(Uris.ResourceCategoryList, {  }).subscribe(result=>{
      // 处理后端返回的数据
      // const { list, totalCount, totalPageCount, pageIndex, pageSize } = result;
      // 更新分类列表
      categories.value = result;
     
    }); 
   
  } catch (error) {
    console.error('Error fetching categories', error);
  }
};




// 新增分类
const showAddCategoryModal = () => {
  categoryForm.id = null;
  categoryForm.name = '';
  categoryForm.sort = null;
  categoryModalVisible.value = true;
};

// 编辑分类
const showEditCategoryModal = (category) => {
  categoryForm.id = category.id;
  categoryForm.name = category.name;
  categoryForm.sort = category.sort;
  categoryModalVisible.value = true;
};

// 提交分类操作（新增或编辑）
const handleCategorySubmit =  () => {  
  // 表单验证
  formRef.value.validate().then(() => {
    try {  
    if (categoryForm.id) {
     // 编辑分类
     http.post(Uris.ResourceCategoryPut, categoryForm).subscribe(t=>{
         fetchCategories(); // 重新加载分类列表
         categoryModalVisible.value = false;
     });
    } else {
     // 新增分类
     http.post(Uris.ResourceCategoryPost, categoryForm).subscribe(t=>{
         fetchCategories(); // 重新加载分类列表
         categoryModalVisible.value = false;
     });
   } 
 } catch (error) {
   console.error('Error submitting category', error);
 }
  })
  .catch(error => {
    console.log('error', error);
  }); 
};
 
// 取消操作
const handleCategoryCancel = () => {
  categoryModalVisible.value = false;
  formRef.value.resetFields();
};

// 删除分类
const deleteCategory = async (category) => {
  try {
    http.get(`${Uris.ResourceCategoryDelete}?id=${category.id}`).subscribe(t=>{
      if(t==0)
      {
        alert("请先删除视频中心数据,再删除该分类!");
      }
      fetchCategories(); 
    }); 
  } catch (error) {
    console.error('Error deleting category', error);
  }
};

// 初始化
onMounted(() => {
  fetchCategories();
});


const rules = {
name: [
  {
    required: true,
    message: '请输入分类名称',
    trigger: 'change',
  }, 
],
sort: [
  {
    required: true,
    message: '请输入排序',
    trigger: 'change',
  }, 
]
};

// 表格列配置
const categoryColumns = [
  {
    title: '序号',
    dataIndex: 'sn',
    key: 'sn', 
    width: 200,
    align: 'center',
  },
  {
    title: '分类名称',
    width: 200,
    dataIndex: 'name',
    key: 'name',
    align: 'center',
  },
 
  {
    title: '排序',
    width: 200,
    dataIndex: 'sort',
    key: 'sort',
    align: 'center', 
  },
  {
    title: '操作',
    width: 200,
    key: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
  },
];
</script>

<style scoped>
p {
padding-left: 20px;
}

</style>
